import { ReservationProvider } from "@/types/modules/reservation";

export const defaultReservationModuleConfig = {
  reservationProvider: "opentable" as ReservationProvider,
  reservationExternalId: "",
  reservationEnabled: false,
};
